var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section-banner',{staticClass:"section-banner-general"}),_c('section-gox-born',{attrs:{"content":_vm.content_gox}}),_c('section-team',{attrs:{"content":_vm.content_team}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }